<!-- The port icons, used by the <use> tags below. To use my own artwork I
     replace the content of a <symbol> (keeping its id and viewBox). The
     .jack-body, .jack-hole and .jack-pins classes get the state colours. -->
<svg class="defs" aria-hidden="true" focusable="false">
  <symbol [attr.id]="uid + '-rj45'" viewBox="0 0 26 22">
    <rect class="jack-body" x="1" y="1" width="24" height="20" rx="2"></rect>
    <path class="jack-hole" d="M5 5.5h16v9h-4v3.5h-8v-3.5h-4z"></path>
    <path class="jack-pins" d="M7.5 5.5v3M9.5 5.5v3M11.5 5.5v3M13.5 5.5v3M15.5 5.5v3M17.5 5.5v3M19.5 5.5v3"></path>
  </symbol>
  <symbol [attr.id]="uid + '-sfp'" viewBox="0 0 26 22">
    <rect class="jack-body" x="1" y="3" width="24" height="16" rx="1.5"></rect>
    <rect class="jack-hole" x="4" y="7.5" width="18" height="7" rx=".5"></rect>
    <path class="jack-pins" d="M8 11h10"></path>
  </symbol>
</svg>

<div class="if-grid">

  <div class="card span12" *ngIf="!ports?.available">
    <div class="card-header">Ports</div>
    <div class="empty">No interface configuration yet. It appears after the
      collector's next poll of the interface endpoints.</div>
  </div>

  <ng-container *ngIf="ports?.available">
  <!-- ================================================== front panel -->
  <div class="card span12" data-ev="card:faceplate">
    <div class="card-header">Ports
      <span class="hdr-note">{{ portsUp }} of {{ portCount }} up<span *ngIf="asOf">, configuration read {{ asOf }}</span></span>
    </div>
    <div class="card-block face-wrap">
      <div class="face-scroll">
        <div class="chassis" role="group" [attr.aria-label]="'Front panel of the ' + title">
          <div class="chassis-id"><span class="chassis-model">{{ title }}</span></div>
          <div class="empty face-empty" *ngIf="!face.length">No physical port reported.</div>
          <div class="port-group" *ngFor="let group of face; trackBy: trackByFace">
            <div class="group-label">{{ group.label }}</div>
            <div class="port-rows">
              <div class="port-row" *ngFor="let row of group.rows; let rowIndex = index"
                   [class.bottom]="rowIndex === 1">
                <button *ngFor="let slot of row; trackBy: trackBySlot" type="button"
                        class="port" [ngClass]="['st-' + slot.state, 'k-' + slot.kind]"
                        [class.unused]="!!slot.port && !slot.port.in_use"
                        [class.spare]="isSpare(slot)"
                        [class.lit]="litPorts.has(slot.name)"
                        [class.sel]="selected === slot.name"
                        [disabled]="!slot.port"
                        [attr.aria-label]="slotAria(slot)"
                        [attr.aria-pressed]="slot.port ? selected === slot.name : null"
                        [attr.aria-describedby]="tip?.slot === slot ? uid + '-tip' : null"
                        (mouseenter)="showTip(slot, $any($event.currentTarget))"
                        (mouseleave)="hideTip()"
                        (focus)="showTip(slot, $any($event.currentTarget))"
                        (blur)="hideTip()"
                        (click)="select(slot.name, 'row')">
                  <span class="port-num" *ngIf="rowIndex === 0">{{ slot.label }}</span>
                  <svg class="port-icon" viewBox="0 0 26 22" aria-hidden="true">
                    <use [attr.href]="'#' + uid + '-' + slot.kind"></use>
                  </svg>
                  <span class="port-num" *ngIf="rowIndex === 1">{{ slot.label }}</span>
                  <span class="port-issue" *ngIf="slot.issue" [ngClass]="'sev-' + slot.issue.sev"
                        aria-hidden="true"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="port-tip" *ngIf="tip?.slot?.port as tipPort" role="tooltip" [id]="uid + '-tip'"
           [class.below]="tip!.below" [style.left.px]="tip!.x" [style.top.px]="tip!.y">
        <div class="tip-head"><b>{{ tipPort.name }}</b><span class="dim" *ngIf="tipPort.alias"> {{ tipPort.alias }}</span></div>
        <div class="tip-state">
          <span class="swatch" [ngClass]="'st-' + tip!.slot.state" [class.spare]="isSpare(tip!.slot)"></span>
          {{ legendText[tip!.slot.state] }}<span *ngIf="speedText(tipPort)">, {{ speedText(tipPort) }}</span>
        </div>
        <dl>
          <ng-container *ngIf="tipPort.member_of"><dt>Member of</dt><dd>{{ memberOfText(tipPort) }}</dd></ng-container>
          <ng-container *ngIf="hasIp(tipPort)"><dt>Address</dt><dd>{{ ipText(tipPort) }}</dd></ng-container>
          <ng-container *ngIf="roleLabel(tipPort.role)"><dt>Role</dt><dd>{{ roleLabel(tipPort.role) }}</dd></ng-container>
          <ng-container *ngIf="tipPort.rx_bps != null || tipPort.tx_bps != null">
            <dt>Now</dt><dd>RX {{ bps(tipPort.rx_bps) }}, TX {{ bps(tipPort.tx_bps) }}</dd></ng-container>
          <ng-container *ngIf="tipPort.mac"><dt>MAC</dt><dd>{{ tipPort.mac }}</dd></ng-container>
          <ng-container *ngIf="tipPort.dhcp_clients"><dt>DHCP clients</dt><dd>{{ tipPort.dhcp_clients }}</dd></ng-container>
        </dl>
        <div class="tip-note" *ngIf="!tipPort.in_use">Not in use: no address, member, VLAN or reference.</div>
        <div class="tip-issue" *ngIf="tip!.slot.issue as tipIssue" [ngClass]="'sev-' + tipIssue.sev">{{ tipIssue.title }}</div>
      </div>

      <div class="face-legend" *ngIf="face.length">
        <span class="key" *ngFor="let legendKey of legend"><span class="swatch" [ngClass]="legendCls[legendKey]"></span>{{ legendText[legendKey] }}</span>
        <span class="key"><span class="swatch st-up unused"></span>Outline: not in use</span>
        <span class="key" *ngIf="selected">
          Showing what uses <b>{{ selected }}</b>
          <button type="button" class="link-btn" (click)="clearSelection()">Clear</button>
        </span>
      </div>
      <p class="face-note" *ngIf="portsUnknown">
        The unit does not report the link of {{ portsUnknown === 1 ? 'one port' : portsUnknown + ' ports' }}
        (usually the ports of a hardware switch), shown in grey.
      </p>
    </div>
  </div>

  <!-- ================================================== interface list -->
  <div class="card span12" data-ev="card:if-list">
    <div class="card-header has-filter">
      <span class="card-title">Interfaces</span>
      <div class="btn-group btn-group-sm" role="group" aria-label="Group the interfaces">
        <button *ngFor="let viewOption of views" type="button" [class.active]="view === viewOption.id"
                [attr.aria-pressed]="view === viewOption.id" (click)="setView(viewOption.id)">{{ viewOption.label }}</button>
      </div>
      <input type="search" class="card-filter" placeholder="Filter"
             aria-label="Filter interfaces by name, alias, address, type or role"
             [value]="filter" (input)="setFilter($any($event.target).value)">
      <button type="button" class="link-btn" [disabled]="!shownCount"
              title="Download the table as shown (grouping and filter included)"
              (click)="exportCsv()">CSV</button>
    </div>
    <div class="tbl-wrap if-tbl-wrap">
      <div class="empty" *ngIf="!rowCount">No interface reported.</div>
      <div class="empty" *ngIf="rowCount && !shownCount">No interface matches.</div>
      <!-- A click on a column title sorts the rows inside each group
           (the VLANs stay under their parent). Same pattern in every table:
           the title is a button, sort.mark() draws the arrow. -->
      <table class="clr if-tbl sortable" *ngIf="shownCount">
        <thead>
          <tr>
            <th class="pill-col" [attr.aria-sort]="sort.ariaSort('status')">
              <button type="button" class="sort-btn" (click)="sortBy('status')">Status <span class="sort-mark" aria-hidden="true">{{ sort.mark('status') }}</span></button></th>
            <th class="pill-col" *ngIf="hasHalfDuplex" [attr.aria-sort]="sort.ariaSort('duplex')">
              <button type="button" class="sort-btn" (click)="sortBy('duplex')">Duplex <span class="sort-mark" aria-hidden="true">{{ sort.mark('duplex') }}</span></button></th>
            <th [attr.aria-sort]="sort.ariaSort('name')">
              <button type="button" class="sort-btn" (click)="sortBy('name')">Name <span class="sort-mark" aria-hidden="true">{{ sort.mark('name') }}</span></button></th>
            <th [attr.aria-sort]="sort.ariaSort('type')">
              <button type="button" class="sort-btn" (click)="sortBy('type')">Type <span class="sort-mark" aria-hidden="true">{{ sort.mark('type') }}</span></button></th>
            <th [attr.aria-sort]="sort.ariaSort('members')">
              <button type="button" class="sort-btn" (click)="sortBy('members')">Members <span class="sort-mark" aria-hidden="true">{{ sort.mark('members') }}</span></button></th>
            <th [attr.aria-sort]="sort.ariaSort('ip')">
              <button type="button" class="sort-btn" (click)="sortBy('ip')">IP/Netmask <span class="sort-mark" aria-hidden="true">{{ sort.mark('ip') }}</span></button></th>
            <th [attr.aria-sort]="sort.ariaSort('access')">
              <button type="button" class="sort-btn" (click)="sortBy('access')">Administrative access <span class="sort-mark" aria-hidden="true">{{ sort.mark('access') }}</span></button></th>
            <th class="num" [attr.aria-sort]="sort.ariaSort('dhcp')">
              <button type="button" class="sort-btn" (click)="sortBy('dhcp')">DHCP clients <span class="sort-mark" aria-hidden="true">{{ sort.mark('dhcp') }}</span></button></th>
            <th class="num" [attr.aria-sort]="sort.ariaSort('refs')">
              <button type="button" class="sort-btn" (click)="sortBy('refs')">Ref. <span class="sort-mark" aria-hidden="true">{{ sort.mark('refs') }}</span></button></th>
          </tr>
        </thead>
        <tbody *ngFor="let group of groups; trackBy: trackByKey">
          <tr class="grp-row" *ngIf="group.label">
            <th [attr.colspan]="hasHalfDuplex ? 9 : 8" scope="colgroup">
              <button type="button" class="grp-toggle" [attr.aria-expanded]="!collapsed.has(group.key)"
                      (click)="toggleGroup(group.key)">
                <span class="chev" aria-hidden="true"></span>{{ group.label }}
                <span class="grp-count">{{ group.count }}</span>
              </button>
            </th>
          </tr>
          <ng-container *ngIf="!collapsed.has(group.key)">
            <tr *ngFor="let row of group.rows; trackBy: trackByRow" class="if-row"
                [class.child]="row.depth > 0" [class.lit]="litRows.has(row.port.name)"
                [class.sel]="selected === row.port.name"
                [attr.data-ev]="'ifrow:' + row.port.name"
                (mouseenter)="hover(row.port.name)" (mouseleave)="hover(null)"
                (click)="select(row.port.name, 'port')">
              <td class="status-cell pill-col">
                <span class="label" *ngIf="statusText(row.port)" [ngClass]="statusCls(row.port)">{{ statusText(row.port) }}</span>
                <span class="dim" *ngIf="!statusText(row.port)">-</span>
                <div class="dim small" *ngIf="listSpeedText(row.port)">{{ listSpeedText(row.port) }}</div>
              </td>
              <!-- its own column, so the pills line up (see hasHalfDuplex) -->
              <td class="pill-col" *ngIf="hasHalfDuplex">
                <span class="label label-warning" *ngIf="row.port.duplex === 0">half</span>
                <span class="dim" *ngIf="row.port.duplex === 1">full</span>
                <span class="dim" *ngIf="row.port.duplex == null">-</span>
              </td>
              <td class="name-cell">
                <span class="tree" *ngIf="row.depth" aria-hidden="true"></span>
                <button type="button" class="if-name" [attr.aria-pressed]="selected === row.port.name"
                        [title]="'Show the ports under ' + row.port.name">{{ row.port.name }}</button>
                <span class="dim" *ngIf="row.port.alias"> ({{ row.port.alias }})</span>
                <div class="dim small" *ngIf="row.port.description">{{ row.port.description }}</div>
                <div class="dim small" *ngIf="row.port.member_of">{{ memberOfText(row.port) }}</div>
              </td>
              <td>
                {{ typeLabel(row.port.type) }}<span class="dim" *ngIf="row.port.members.length"> ({{ row.port.members.length }})</span>
                <div class="dim small" *ngIf="row.port.vlanid">VLAN ID {{ row.port.vlanid }}</div>
              </td>
              <td class="members-cell">
                <span class="mini-port" *ngFor="let slot of row.memberPorts; trackBy: trackBySlot"
                      [ngClass]="'st-' + slot.state" [class.spare]="isSpare(slot)" [class.lit]="litPorts.has(slot.name)"
                      [title]="slotAria(slot)">
                  <span class="mini-num">{{ slot.label }}</span>
                  <svg viewBox="0 0 26 22" aria-hidden="true"><use [attr.href]="'#' + uid + '-' + slot.kind"></use></svg>
                </span>
                <span class="member-name" *ngFor="let memberName of row.memberNames">{{ memberName }}</span>
              </td>
              <td>
                <span [class.dim]="!hasIp(row.port)">{{ ipText(row.port) || '-' }}</span>
                <span class="label label-info" *ngIf="row.port.mode === 'dhcp'" title="Address obtained by DHCP">DHCP</span>
                <span class="label label-info" *ngIf="row.port.mode === 'pppoe'" title="Address obtained by PPPoE">PPPoE</span>
              </td>
              <td class="access-cell">
                <span class="acc" *ngFor="let access of row.port.access" [class.bad]="row.port.insecure.includes(access)"
                      [title]="row.port.insecure.includes(access) ? 'Clear-text protocol: credentials cross the network unencrypted' : ''">{{ accessLabel(access) }}</span>
              </td>
              <td class="num"><span [class.dim]="!row.port.dhcp_clients">{{ row.port.dhcp_clients || '' }}</span></td>
              <td class="num"><span [class.dim]="!row.port.refs">{{ row.port.refs ?? '' }}</span></td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
  </ng-container>
</div>
